import React from 'react'
import * as R from 'ramda'
import styled from 'styled-components'
import { Message } from 'semantic-ui-react'

import useModal from 'hooks/useModal'
import CreateWidgetModal from 'components/CreateWidgetModal'
import { Loader } from 'shared/components/Loader'
import IndividualWidgetSegment from 'components/IndividualWidgetSegment'
import usePermission from 'hooks/usePermission'
import { AdminContainer } from '../'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { LimitFeatureButton } from 'components/LimitFeatureButton'
import { CrownBadge } from 'components/ProFeatureLabel'
import useWorkspace from 'hooks/useWorkspace'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

/**
 * @typedef Widget
 * @property {string} id
 * @property {string} name
 * @property {string} type
 */

export default function TestimonialsPageV2({
  widgets,
  createWidget,
  deleteWidget,
  createWidgetAPILoading,
  deleteWidgetAPILoading,
  widgetsLoading,
}) {
  const { Modal, open } = useModal()
  const { user } = usePermission()

  const featureLimit = R.path(
    ['subscription', 'subscription_items_metadata', 'feedback_widgets'],
    user
  )

  return (
    <React.Fragment>
      <PageHeaderContainer
        title="Feedback widgets"
        rightSlot={
          <AllowPermission permission={constants.permissions.manageFeedbackWidgets}>
            <LimitFeatureButton
              featureLimit={featureLimit}
              usageCount={widgets.length}
              handleClick={open}
              descriptionTitle={
                <span className="flex items-center">
                  Widget limit reached <CrownBadge />
                </span>
              }
              descriptionContent={
                "You've reached your account's widget limit. Please remove widgets or upgrade your plan to add more."
              }
              learnMoreLink={
                'https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings'
              }
              buttonText={'New feedback widget'}
              loading={widgetsLoading}
            />
          </AllowPermission>
        }
      />
      <AdminContainer>
        <div className="ui segment admin-section">
          <p>
            Keep your website current by easily publishing customer testimonials from Simplesat to
            your website with just one click.
          </p>
          <p>
            <a
              href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings"
              target="_blank"
              rel="noreferrer"
            >
              <i className="icon far fa-book" />
              Learn more about publishing customer feedback and ratings
            </a>
          </p>
          <WidgetList
            widgets={widgets}
            deleteWidget={deleteWidget}
            deleteWidgetAPILoading={deleteWidgetAPILoading}
          />
        </div>
      </AdminContainer>
      <Modal size="large">
        <CreateWidgetModal
          createWidget={createWidget}
          createWidgetAPILoading={createWidgetAPILoading}
        />
      </Modal>
    </React.Fragment>
  )
}

const SegmentGroup = styled.div`
  .ui.segment {
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  &.ui.segments .ui.segment:only-of-type {
    border: none;
  }
`

function WidgetList({ widgets, deleteWidget, deleteWidgetAPILoading }) {
  const workspaceToken = useWorkspace()
  if (!widgets) {
    return <Loader withContainer />
  }

  if (widgets.length === 0) {
    return (
      <Message content="You don't have any feedback widgets yet. Create a new one to get started." />
    )
  }

  return (
    <SegmentGroup className="ui segments">
      {widgets.map((widget) => (
        <IndividualWidgetSegment
          key={widget.id}
          widget={widget}
          workspaceToken={workspaceToken}
          onDelete={() => {
            deleteWidget(widget.id)
          }}
          deleteWidgetAPILoading={deleteWidgetAPILoading}
        />
      ))}
    </SegmentGroup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/TestimonialsV2/index.js